import React, { useState } from "react";
import searchParticipants from "../../helpers/searchParticipants";
import { AdminParticipantEntry } from "../../helpers/adminTypes";
import { IconBarcode, IconPhone, IconUsers } from "./AdminIcons";
import "../../Admin.scss";

const initials = (name: string | null): string => {
  if (!name) return "?";
  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
};

const AdminParticipants: React.FC = () => {
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [rows, setRows] = useState<AdminParticipantEntry[] | null>(null);

  const handleSearch = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setMessage("");
    const result = await searchParticipants({
      phone: phone.trim() || undefined,
      code: code.trim() || undefined,
    });
    const data = Array.isArray(result.data) ? result.data : [];
    setLoading(false);
    setRows(data);

    if (result.code === 400) {
      setMessage("Unesi telefon ili kod za pretragu.");
      return;
    }
    if (result.code !== 200) {
      setMessage("Pretraga nije uspela. Pokušaj ponovo.");
      return;
    }
    if (data.length === 0) {
      setMessage(
        phone.trim()
          ? "Nema prijava za ovaj telefon."
          : "Nema prijava za ovaj kod."
      );
      return;
    }
    setMessage("");
  };

  return (
    <section className="admin-page">
      <header className="admin-page-head">
        <div>
          <h1>Takmičari</h1>
          <p className="admin-lede">Pregled prijava po telefonu ili kodu</p>
        </div>
        {rows && (
          <div className="admin-count-pill">
            <IconUsers />
            {rows.length} prijava
          </div>
        )}
      </header>

      <form className="admin-card admin-search" onSubmit={handleSearch}>
        <div className="admin-search-field">
          <span className="admin-search-label">Telefon</span>
          <div className="admin-input-icon is-phone">
            <IconPhone />
            <input
              id="search-phone"
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
                if (e.target.value) setCode("");
              }}
              placeholder="Pretraži po telefonu..."
            />
          </div>
        </div>
        <div className="admin-search-field">
          <span className="admin-search-label">Kod</span>
          <div className="admin-input-icon is-code">
            <IconBarcode />
            <input
              id="search-code"
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                if (e.target.value) setPhone("");
              }}
              placeholder="npr. R4NNR5M7R5"
            />
          </div>
        </div>
        <button type="submit" className="admin-btn admin-search-btn" disabled={loading}>
          {loading ? "Pretraga..." : "Pretraži"}
        </button>
      </form>

      {rows && rows.length === 0 && (
        <div className="admin-empty">
          <div className="admin-empty-icon">
            <IconUsers />
          </div>
          <h2>Nema rezultata</h2>
          <p>{message || "Nema prijava za uneti telefon ili kod."}</p>
        </div>
      )}

      {rows && rows.length > 0 && (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Takmičar</th>
                <th>Kod</th>
                <th>Telefon</th>
                <th>Email</th>
                <th>Tip</th>
                <th>Dobitnik</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>
                    <div className="admin-person">
                      <span className="admin-avatar">{initials(row.name)}</span>
                      <span>
                        <strong>{row.name || "—"}</strong>
                        <small>Prijava: {row.date}</small>
                      </span>
                    </div>
                  </td>
                  <td>{row.code}</td>
                  <td>{row.identity}</td>
                  <td>{row.email || "—"}</td>
                  <td>
                    <span className="admin-pill is-available">{row.type}</span>
                  </td>
                  <td>
                    <span
                      className={`admin-pill ${
                        row.already_win ? "is-winner" : "is-plain"
                      }`}
                    >
                      {row.already_win ? "da" : "ne"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};

export default AdminParticipants;
